// VerticalResizeHandle.js
import React, { useRef } from 'react';
import { Box } from '@mui/material';

export default function VerticalResizeHandle({
                                                 positionPx,                        // distance from right edge in pixels OR undefined if using %
                                                 onDrag,                            // (deltaX) => void
                                                 ariaLabel = 'Resize',
                                                 thickness = 6,
                                                 zIndex = 1300,
                                                 rightCss,                          // optional: override 'right' if you’re using % widths
                                             }) {
    const dragging = useRef(false);
    const lastX = useRef(0);

    const onPointerDown = (e) => {
        dragging.current = true;
        lastX.current = e.clientX;
        document.body.style.userSelect = 'none';
        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp);
    };
    const onPointerMove = (e) => {
        if (!dragging.current) return;
        const dx = e.clientX - lastX.current;
        lastX.current = e.clientX;
        onDrag(dx);
    };
    const onPointerUp = () => {
        dragging.current = false;
        document.body.style.userSelect = '';
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
    };

    return (
        <Box
            role="separator"
            aria-label={ariaLabel}
            onPointerDown={onPointerDown}
            sx={{
                position: 'fixed',
                top: 64,             // matches your app bar offset
                bottom: 0,
                right: rightCss ?? (positionPx != null ? `${positionPx}px` : 0),
                width: thickness,
                cursor: 'col-resize',
                zIndex,
                // “fat” hit target: invisible gutter around a visible line
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    background:
                        'linear-gradient(to right, transparent 45%, rgba(0,0,0,0.12) 50%, transparent 55%)',
                },
            }}
        />
    );
}
